import { t } from '@avalara/bat-apps-shared/i18n';
import { SDialog } from '@avalara/skylab-sdk/react';

import './product-catalog.css';

type Props = {
  dialogOpen: boolean;
  handleDismissDialog: () => void;
};

// Dismiss-only (BRGUI-2696) -- unlike ContactDialog, no in-flight async operation ever blocks
// dismissal here, so this skips its noDismiss/forceReassertOpen machinery entirely.
const OrderInProgressDialog = ({ dialogOpen, handleDismissDialog }: Props) => (
  <SDialog
    id='product-catalog-order-in-progress-dialog'
    data-ref='buy.product-catalog.order-in-progress-dialog'
    onS-dismiss={handleDismissDialog}
    open={dialogOpen}
  >
    <div slot='header' data-ref='buy.product-catalog.order-in-progress-dialog.header'>
      {t('client.product-catalog.order-in-progress-dialog.title')}
    </div>
    <div slot='body' data-ref='buy.product-catalog.order-in-progress-dialog.body'>
      <p className='font-light'>{t('client.product-catalog.order-in-progress-dialog.body')}</p>
    </div>
    <div slot='footer' data-ref='buy.product-catalog.order-in-progress-dialog.footer'>
      <button
        type='button'
        data-ref='buy.product-catalog.order-in-progress-dialog.close-button'
        className='secondary'
        onClick={handleDismissDialog}
      >
        {t('client.buttons.close')}
      </button>
    </div>
  </SDialog>
);

export default OrderInProgressDialog;
